import consumer from "./consumer"

const createSubscription = (projectId) => {
  return consumer.subscriptions.create(
    { channel: "TaskListsChannel", project_id: projectId},
    {
      received(data) {
        const taskListsContainer = document.getElementById("task-lists-list")
        if ( taskListsContainer && data.html ) {
          taskListsContainer.outerHTML = data.html
        }
      }
    }
  )
}

export default createSubscription
